/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderpickerTarget } from '../../models/orderpicker-target';
import { UpdateOrderpickerTargetDto } from '../../models/update-orderpicker-target-dto';

export interface UpdateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params {
  orderpickerId: number;
  id: number;
      body: UpdateOrderpickerTargetDto
}

export function updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderpickerTarget>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget.PATH, 'patch');
  if (params) {
    rb.path('orderpickerId', params.orderpickerId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderpickerTarget>;
    })
  );
}

updateOneBaseMgmtOrderpickerTargetControllerOrderpickerTarget.PATH = '/api/mgmt/orderpicker/{orderpickerId}/targets/{id}';
